import Jurisdiction from './jurisdiction';
import LoggedInUser from './loggedInUser';
import Vendor from './vendor';

export default class Navigation {
  constructor(public loggedInUser:  LoggedInUser,
    public jurisdictions:  Jurisdiction[],
    public vendors: Vendor[]) {
  }

  static createFromRequest(request: any): Navigation {

    const jurisdictions = new Array<Jurisdiction>();
    const vendors = new Array<Vendor>();
    const loggedInUser = LoggedInUser.createFromRequest(request.loggedInUser);

    for (const jurisdiction of request.jurisdictions) {
      jurisdictions.push(Jurisdiction.createFromRequest(jurisdiction));
    }

    for (const vendor of request.vendors) {
      vendors.push(Vendor.createFromRequest(vendor));
    }

    return new Navigation(loggedInUser, jurisdictions, vendors);
  }
}



// WEBPACK FOOTER //
// ./src/models/navigation.ts